import React, {FC, InputHTMLAttributes} from 'react';

import {useTranslation} from "react-i18next";
import {ReactSVG} from "react-svg";

interface Props extends InputHTMLAttributes<any> {
  label: string;
  className?: string;
  icon?: any
}

const Input: FC<Props> = ({
                            label,
                            className,
                            icon,
                            ...props
                          }) => {
  const {t} = useTranslation();
  return (
    <div className={`form-group${props.value ? ' filled' : ''} ${className || ''}`}>
      <textarea className={`form-control${icon ? ' form-control-icon' : ''}`} {...props} />
      <div className={`form-input-placeholder`}>{t(label)}</div>
    </div>
  );
}

export default Input;